import React from 'react';
import { Link } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50">
      <div className="flex justify-between items-center h-16 px-6">
        <div className="flex items-center pl-[2px]">
          <Link to="/" className="flex items-center">
            <img src="https://assets.taar.ai/logo.png" alt="Taar.AI" className="h-8 w-auto" style={{maxHeight: '32px'}} />
          </Link>
        </div>
        <div className="sm:ml-6 flex space-x-8">
          <Link to="/docs" className="text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 border-indigo-500 text-sm font-medium">
            Docs
          </Link>
        </div>
        <div className="flex items-center">
          <button className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
            <MagnifyingGlassIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 